<template>
  <div class="row">
    <div class="row col-12" id="buttonRow">
      <!-- col-11 for spacing -->
      <div class="col-11">
        <h4 class="edit-action-text">{{ $t("My actions") }}</h4>
        <h1 v-html="actionData.title"></h1>
      </div>
      <div class="col-1">
        <button class="btn btn-sm btn-rounded btn-info edit-button" v-on:click="$router.push('/editAction/' + $route.params.id)">
          {{ $t("Edit action") }}
        </button>

      </div>
    </div>

    <!-- Column 1 Actions edit: Repair machine-->
    <div class="col-lg-6 col-md-12" v-if="typeof actionData === 'object'">
      <div class="card">
        <div class="card-body">
          <div v-if="Object.keys(actionData).length !== 0" class="actions-details">
            <div v-show="short">
              <h4>{{ $t("Description") }}</h4>
              <vue-markdown>{{ actionData.description | cutText(120) }}</vue-markdown>
            </div>
            <div v-show="!short">
              <h4>{{ $t("Description") }}</h4>
              <vue-markdown>{{ actionData.description }}</vue-markdown>
            </div>
            <a v-if="short && actionData.description.length > 120" @click="short = false"><i class="ti-plus"></i> {{ $t("read more") }}</a>
            <a v-if="!short" @click="short = true"><i class="ti-plus"></i> {{ $t("read less") }}</a>
            <hr>

            <div class="row">
              <div class="col">
                <p></p><h4 class="">{{ $t("Start Date") }}</h4>
                {{ actionData.date_start | formatDate }}<p></p>

                <p></p><h4 class="">{{ $t("Owner") }}</h4>
                {{ actionData.Owner.firstname }} {{ actionData.Owner.lastname}}<p></p>

                <p>
                </p><h4>{{ $t("Meeting Source") }}</h4>
                <template v-if="actionData.MeetingSource.length === 0">
                  {{ $t("No meeting source") }}
                </template>
                <template v-else-if="actionData.MeetingSource.description !== null">
                  {{ actionData.MeetingSource.description }}
                </template>
                <template v-else>
                  {{ $t("Source meeting has no description") }}
                </template>
                <p></p>

                <h4>{{ $t("Related Problem") }}</h4>
                <p>
                  <template v-if="actionData.KpiProblemCause.length !== 0">
                    {{ actionData.KpiProblemCause.name }}
                  </template>
                  <template v-else>
                    {{ $t("No related problem") }}
                  </template>
                </p>

              </div>
              <div class="col">
                <p></p><h4 class="">{{ $t("Due Date") }}</h4>
                {{ actionData.date_end | formatDate }}<p></p>
                <p>
                </p><h4>{{ $t("Created by") }}</h4>
                <p>{{ actionData.Creator.firstname}} {{ actionData.Creator.lastname }}</p>

                <h4>{{ $t("Related KPI") }}</h4>
                <p>
                  <template v-if="actionData.Kpi.length !== 0">{{ actionData.Kpi.name }}</template>
                  <template v-else>{{ $t("No related KPI") }}</template>
                </p>

                <h4>{{ $t("% Contribution to solution") }}</h4>
                <p>
                  <template v-if="actionData.kpi_contribution !== null">{{ actionData.kpi_contribution }}%</template>
                  <template v-else>{{ $t("No contribution specified") }}</template>
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- / Column 1 Actions edit: Repair machine-->


    <!-- Column 2 Actions edit: Status-->
    <div class="col-lg-6 col-md-12">
      <div class="card">
        <div v-if="Object.keys(actionData).length !== 0" class="card-body">
          <div>
            <div>

              <h3 class="card-title">{{ $t("Status") }}</h3>

              <div class="row">
                <div class="col-4 status-text">
                  <i v-if="actionData.status === 'accept'" class="ti-settings text-info"></i>
                  <i v-else-if="actionData.status === 'done'" class="ti-check text-success"></i>
                  <i v-else-if="actionData.status === 'declined'" class="ti-close text-danger"></i>
                  <i v-else class="ti-more-alt text-info"></i>
                  {{ $t(actionData.status) | ucFirst }}
                </div>
                <div class="col-8 text-right" v-if="actionData.status === 'accept'">
                  <button type="button" v-on:click="processUpdate(true)" class="btn btn-sm btn-success btn-rounded p-r-10"><i class="ti-check"></i> {{ $t("Accept") }}</button>
                  <button type="button" v-on:click="processUpdate(false)" class="btn btn-sm btn-danger btn-rounded"><i class="ti-close"></i> {{ $t("Decline") }}</button>
                </div>
                <div class="col-8 text-right" v-else-if="actionData.status === 'pending'">
                  <button type="button" v-on:click="processUpdate(true)" class="btn btn-sm btn-success btn-rounded p-r-10"><i class="ti-check"></i> {{ $t("Finish") }}</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="d-flex">
            <div>
              <h3 class="card-title">{{ $t("Activity") }}</h3></div>
            <div class="ml-auto">
              <button type="button" class="btn btn-sm btn-rounded btn-info" data-toggle="modal" data-target="#modalNote"><i class="ti-plus"></i> {{ $t("Add note") }}</button>
            </div>
          </div>
        </div>

        <!-- Add NOTE modal content -->
        <div id="modalNote" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h3 class="modal-title" id="myModalLabel">{{ $t("Add note") }}</h3>
                <div class="pull-right">
                  <button type="button" class="close p-l-20 p-t-5 text-info" data-dismiss="modal" aria-hidden="true"><i class="ti-close"></i></button>
                </div>

              </div>
              <div class="modal-body">
                {{ $t(" Related action") }} <span class="text-muted">{{ actionData.title }}</span>

                <div class="m-t-20">

                  <div class="form-group row">
                    <label class="col-sm-12 control-label">Note</label>
                    <div class="col-sm-12">
                      <div class="input-group">
                        <textarea v-model="note" class="form-control" rows="5" placeholder="Leave note here"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row m-b-0">
                    <div class="offset-sm-12 col-sm-12 pull-right">
                      <button class="btn btn-sm btn-rounded btn-info" data-toggle="modal" data-target="#modalNote" v-on:click="addNote()" >{{ $t("Add note") }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->


        <!-- ============================================================== -->
        <!-- Activity widgets -->
        <!-- ============================================================== -->
        <div v-if="Object.keys(actionData).length !== 0" class="table-responsive">
          <table class="table vm no-th-brd pro-of-month">
            <tbody>
            <tr v-for="log in actionData.ActionLogs.data" v-on:click="$emit('toggleLog', log.uid)">

              <td style="" class="date-display">
                <div class="p-2 m-t-0" v-html="$options.filters.formatDateDay(log.timestamp)"></div>


              </td>
              <td>
                <action-note v-if="log !== null" :log="log"></action-note>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import APIHelper from "../mixins/APIHelper";
  import ActionNote from "./ActionNote";
  export default {
    name: "actions-detail",
    components: {ActionNote},
    data: function () {
      return {
        actionData: {},
        note: "",
        userData: APIHelper.getUserData(),
        short: true
      }
    },
    created() {
      this.loadAction();
    },
    methods: {
      loadAction: function () {
        let vm = this;
        let actionId = this.$route.params.id;
        let args = {
          "include": "Owner,Creator,Kpi,KpiProblemCause,MeetingSource,ActionLogs"
        };
        APIHelper.getResource("/api/action/" + actionId, args).then((data) => {

          vm.actionData = data;
          vm.actionData.ActionLogs.data.map(action => action.expanded = false);
          this.$parent.$emit("addTitleBreadcrumb", vm.actionData.title);
          // Fix, necessary for mobile
          window.scrollTo(0,0);
        });
      },
      addNote: function () {
        let vm = this;

        let data_to_send = {
          user_uid: vm.userData.uid,
          note: vm.note
        };

        APIHelper.postResource("/api/action/" + this.$route.params.id + "/note", data_to_send).then((data) => {
          data.timestamp = moment();
          data.User = {
            firstname: vm.userData.firstname,
            lastname: vm.userData.lastname
          };

          vm.$notify({
            group: "notification",
            title: vm.$t("Success"),
            text: vm.$t("Note added successfully"),
            type: "success"
          });
          if(typeof vm.actionData.ActionLogs.data === 'undefined'){
            vm.actionData.ActionLogs.data = [];
          }
          vm.actionData.ActionLogs.data.unshift(data);
          vm.note = "";
        });

      },
      processUpdate: function (accepted) {
        let vm = this;

        let status = "";
        if (!accepted){
          status = "declined";
        } else if (vm.actionData.status === 'pending') {
          status = "done";
        } else {
          status = "pending";
        }

        let data_to_send = {
          status: status
        };

        APIHelper.patchResource("/api/action/" + vm.$route.params.id, data_to_send).then((data) => {
          vm.actionData.status = data.status;
          vm.$notify({
            group: "notification",
            title: vm.$t("Success"),
            text: vm.$t("Status updated successfully"),
            type: "success"
          });
          let logData = {
            User: {
              firstname: vm.userData.firstname,
              lastname: vm.userData.lastname
            },
            note: vm.$t("Changed status to ") + status,
            timestamp: moment(),
            expanded: false
          };

          if (typeof vm.actionData.ActionLogs.data === 'undefined') {
            vm.actionData.ActionLogs.data = [];
          }
          vm.actionData.ActionLogs.data.unshift(logData);
        });
      }
    },
    beforeDestroy(){
      this.$parent.$emit("removeTitleBreadcrumb");

    }
  }
</script>

<style scoped>
  div#buttonRow{
    margin-bottom: 25px;
  }

  .edit-action-text{
    color: #68768e;
  }

  .status-text{
    font-size: 14pt;
  }
  .status-text:not(i){
    color: #67757c;
  }
  .status-text i{
    margin-right: 5px;
  }

  .edit-button{
    margin-left: -20px;
  }

  .actions-details *:not(h4){
    color: #67757c;
  }
  .actions-details h4{
    margin-bottom: 5px;
  }

  .date-display{
    vertical-align: top;
    min-width: 150px;

  }

  .table {
    width: initial !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ActionsDetail.vue